import { defaultBodyFont, blackColors } from 'assets/jss/material-dashboard-pro-react';

const addLineDialogStyle = () => ({
	dialog: {
		'& .MuiPaper-root': {
			width: 620,
		},
	},
	confirmationEmail: {
		paddingTop: 8,
		marginBottom: 8,
		marginTop: 17,
		borderTop: `1px solid ${blackColors[6]}`,
	},
	dialogBodyWrapper: {
		paddingTop: '24px',
		minHeight: '460px',
		'& > div > div:last-of-type': {
			width: '300px',
			maxWidth: '80%',
			margin: '26px auto 0',
		},
	},
	simReplacementImage: {
		marginTop: '3px',
		width: '147px',
		display: 'block',
		margin: '0 auto',
	},
	menuItemWrapper: {
		userSelect: 'none',
	},
	searchWrapper: {
		height: '55px',
	},
	additionalMargin: {
		marginBottom: '30px',
	},
	smallMargin: {
		marginBottom: '8px',
	},
	mediumMargin: {
		marginBottom: '24px',
	},
	summaryTab: {
		marginTop: '45px',
	},
	servicesTab: {
		minHeight: '400px',
		'& > div': {
			'& > p': {
				marginBottom: '8px',
				'&:first-of-type': {
					marginBottom: '16px',
				},
			},
			'& .MuiFormControlLabel-root': {
				padding: 0,
			},
		},
	},
	creditLimitCurrency: {
		...defaultBodyFont,
		fontSize: 14,
	},
	tariffWrapper: {
		marginTop: '30px',
		textAlign: 'left',
	},
	creditLimitWrapper: {
		maxWidth: '162px',
		marginTop: '-8px',
		position: 'relative',
		zIndex: 11,
		'& .MuiFormControl-root': {
			marginBottom: 0,
		},
	},
	selectedAccount: {
		'& p': {
			marginBottom: 0,
		},
	},
	selectedItem: {
		'& > p': {
			marginBottom: 0,
		},
	},
	mobileInternetPlans: {
		marginBottom: '56px',
	},
	gsmServices: {
		marginBottom: '40px',
		marginTop: '20px',
	},
	cpnRadioButtons: {
		marginBottom: '24px',
	},
	numberSearchWrapper: {
		marginBottom: '16px',
	},
	cpnHeader: {
		marginBottom: '16px',
		'& > span': {
			paddingRight: '6px',
		},
	},
	selectPhoneNumberDescription: {
		marginTop: '40px',
	},
	numbersSearchWrapper: {
		marginTop: '46px',
	},
	planTabWrapper: {
		width: 1000,
		maxWidth: '100%',
		marginLeft: 'auto',
		marginRight: 'auto',
	},
	tabWrapper: {
		width: 500,
		maxWidth: '100%',
		marginLeft: 'auto',
		marginRight: 'auto',
	},
	smWidth: {
		width: 288,
		maxWidth: '100%',
		margin: '0 auto',
	},
	circularProgressContainer: {
		position: 'absolute',
		zIndex: 2,
		height: 530,
		width: 560,
		'& > div': {
			height: 530,
		},
	},
	builtInInternationalRoaming: {
		paddingTop: 20,
		paddingBottom: 30,
	},
	successBoxWrapper: {
		maxWidth: 275,
		margin: '10px auto 0 auto',
		textAlign: 'center',
	},
	NoServices: {
		marginTop: '50px',
	},
	otpContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
});

export default addLineDialogStyle;
